import React from 'react'
import { withTranslation } from 'react-i18next'
import BackAnchor from 'shared/components/BackAnchor'

const ScreeningQuestionYesView = ({ t, i18n }) => {
  const paymentURL = i18n.language === 'en' ? 'https://beta.novascotia.ca/pay-fine-ticket' : 'https://beta.novascotia.ca/fr/payer-une-amende-contravention'

  return (
    <div className="container">
      <main>
        <article className="col-md-8">
          <BackAnchor backPath='routes.screening_question' />
          <h1>{t('title')}</h1>
          <div className="row">
            <div className="col-xs-12">
              <h2>
                {t('screening_question_yes.if_you_want_to_pay_doj')}
                <a href={paymentURL} target="_blank" rel="noopener noreferrer">{t('screening_question_yes.fine_payments_link')}</a>
                {t('screening_question_yes.to_pay_fine_online')}
              </h2>
            </div>
          </div>
        </article >
      </main >
    </div >
  )
}

export default withTranslation('common')(ScreeningQuestionYesView)
